import { NgModule } from "@angular/core";
import { RepositoryFactoryProvider } from "../../../common/utils/backend.provider";
import { LocalStorageRepositoryInterface } from "../local-storage/local-storage.interface";
import { LoadingOverlayService } from "../../components/loading-overlay/services/loading-overlay.service";
import { RouterService } from "../../services/router.service";
import { TokenService } from "../../services/user/token.service";
import { UsersHttpBackend } from "../users/users.backend";
import { CountriesRepositoryInterface } from "./countries.interface";
import { CountriesRepository } from "./countries.repository";

@NgModule({
  providers: [
    RepositoryFactoryProvider({
      provide: CountriesRepositoryInterface,
      repository: CountriesRepository,
      backend: UsersHttpBackend,
      deps: [
        LocalStorageRepositoryInterface,
        RouterService,
        LoadingOverlayService,
        TokenService
      ]
    })
  ]
})
export class CountriesRepositoryModule { }